import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Button from "../../../components/buttons/Button";
import Content from "../../../components/Content";
import InputField from "../../../components/Inputs/InputField";
import * as serviceApi from "../../../hooks/useServiceData";
import Check from "../../../components/Inputs/Check";
import { useSnackbar } from "notistack";

export const ActivityEditView = () => {
  const navigate = useNavigate();
  const { id: activityId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [edited] = useState(false);

  const [name, setName] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const [cost, setCost] = useState("");
  const [isActive, setIsActive] = useState(true);

  const { data } = serviceApi.GetActivity(activityId);
  const { mutate } = serviceApi.UpdateActivity();

  useEffect(() => {
    if (data?.data) {
      setName(data?.data.name);
      setOwnerId(data?.data.owner_id);
      setCost(data?.data.cost);
      setIsActive(data?.data.isActive === 1 ? true : false);
    }
  }, [data]);

  const updateActivity = () => {
    let _activity = {};

    _activity.activityId = data?.data.id;
    _activity.name = name;
    _activity.owner_id = ownerId;
    _activity.cost = cost;
    _activity.isActive = isActive;

    mutate(_activity, {
      onSuccess: () => {
        enqueueSnackbar("Aktivitet uppdaterad.", {
          variant: "success",
        });
        navigate(`/registry/activity/details/${activityId}`);
      },
      onError: (error) => {
        enqueueSnackbar("Kunde inte uppdatera Aktivitet.", {
          variant: "error",
        });
        console.log("ERROR UPDATING ACTIVITY", error);
      },
    });
  };

  return (
    <>
      <Content title={`${data?.data.name}`}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            updateActivity();
          }}
          className="container"
          style={{ width: "100%" }}
        >
          <div className="form-grid-auto">
            <InputField
              required
              label={"Aktivitetens namn"}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <InputField
              required
              label={"Aktivitetens id"}
              value={ownerId}
              onChange={(e) => setOwnerId(e.target.value)}
            />
            <InputField
              required
              type="number"
              label={"Aktivitetens kostnad"}
              value={cost}
              onChange={(e) => setCost(e.target.value)}
            />
          </div>

          <Check
            color="success"
            label="Aktiv Aktivitet"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
          />

          <div className="rightAlign-button-container">
            <Button
              className={edited ? "button-pulse" : undefined}
              disabled={!edited}
              type="submit"
              color="success"
            >
              Spara
            </Button>
          </div>
        </form>
      </Content>
    </>
  );
};
